/* eslint-disable no-unused-vars */
export enum LOGIN_TYPES {
  SIGNIN = 'signin',
  SIGNUP = 'signup',
}

export enum SocialMediaType {
  Facebook = 'facebook',
  Google = 'google',
  Apple = 'apple',
  Empty = '',
}
/* eslint-enable no-unused-vars */
